// extracted by mini-css-extract-plugin
export default {"ReplaceLink":"ReplaceLink_ReplaceLink__LD-wS"};